import { environment as env } from "../../../../../../environments/environment";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class ContactService {

    constructor(private http: HttpClient) {}

    public getContact(id) {
        const url = `${env.apiPath}/contacts/${id}`;
        return this.http.get(url);
    }

    public createContact(contact) {
        const url = `${env.apiPath}/contacts`;
        return this.http.post(url, contact);
    }

    public updateContact(contact) {
        const url = `${env.apiPath}/contacts/${contact.id}`;
        return this.http.put(url, contact);
    }
};
